import { cloneDeep } from "lodash";
import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import AppButton from "../../common/AppButton";
import AppInput from "../../common/AppInput";
import numberFormat from "../../common/numberFormat";
import api from "../../config/api";
import SmallForm from "../../skelliton/SmallForm";
import { toast } from "react-toastify";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { getExpenseCategories } from "../../stores/ExpenseCategoryStore";

const formInit = {
  date: new Date(),
  category: "",
  amount: "",
  invoice: "",
  comment: "",
};
export default function ExpenseAddModel() {
  const queryClient = useQueryClient();

  const { data: categories } = useQuery({
    queryFn: () => getExpenseCategories(),
    queryKey: ["expenseCategory"],
  });

  const Body = ({ onDone }) => {
    const [disabled, setDisabled] = useState(false);

    const [form, setForm] = useState(cloneDeep(formInit));
    const handleSubmit = async (event) => {
      event.preventDefault();
      if (!form.category) {
        document.querySelector("#category input").focus();
        return false;
      }

      setDisabled(true);
      const res = await api.post("expenses", {
        ...form,
      });
      if (!res.ok) {
        setDisabled(false);
        toast.error(res.originalError.message);
      }
      queryClient.invalidateQueries(["expenses"]);

      setForm(formInit);
      setDisabled(false);
      toast.success("Expense has been successfully added.");
      onDone && onDone();
    };
    const handleChange = ({ target }) => {
      const name = target.name;
      const value = target.value;
      setForm({ ...form, [name]: value });
    };
    return (
      <form id="form" onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <span className="d-flex" style={{ alignItems: "center" }}>
            <b>Add Expenses</b>
          </span>
        </Modal.Header>
        <br />
        <br />
        {!categories && (
          <div className="d-flex" style={{ justifyContent: "center" }}>
            <SmallForm />
          </div>
        )}
        {categories && (
          <div style={{ padding: "0px 30px" }}>
            <div
              className="d-flex"
              style={{
                gap: "0px 30px",

                alignItems: "flex-start",
              }}
            >
              <AppInput
                type="date"
                name="date"
                placeholder="Date"
                label="Date"
                floatLabel
                value={form.date}
                onChange={handleChange}
                required
              />
              <AppInput
                type="dropdown"
                options={categories?.map((i) => ({ ...i, name: i.category }))}
                name="category"
                id="category"
                value={form.category}
                filterBy="name"
                onChange={handleChange}
                label="Category"
                floatLabel
                containerStyle={{ height: 95 }}
              />
            </div>
            <br />
            <br />

            <div className="d-flex" style={{ gap: "0px 30px" }}>
              <AppInput
                name="amount"
                value={numberFormat(form.amount)}
                onChange={handleChange}
                required
                label="Amount ($)"
                floatLabel
              />
              <AppInput
                name="invoice"
                value={form.invoice}
                onChange={handleChange}
                required
                label="Invoice"
                floatLabel
              />
              <AppInput
                name="comment"
                value={form.comment}
                onChange={handleChange}
                required
                label="Comment"
                floatLabel
              />
            </div>
          </div>
        )}
        <br />
        <br />
        <br />
        <Modal.Footer>
          <AppButton
            disabled={disabled}
            text="Add Expense"
            form="form"
            type="submit"
            className="text-primary btn-light"
          />
        </Modal.Footer>
      </form>
    );
  };

  return {
    Body,
  };
}
